module.exports = __webpack_public_path__ + "assets/img/3e3695fe5a3686b2b5d1a88651b0a23e.svg";